import WithRender from "../../templates/buttons/addToCartButton.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";
import * as R from "ramda";

export default WithRender({
  computed: {
    ...mapGetters([
      "getAddToCartCallbacks",
      "getOnCartSubmitCallback",
      "getHasAutomaticConnect",
      "getFilesConnectLoading",
      "getNumberOfActiveUploads",
      "getIsChangeOptionsLoading",
      "getIsValidForm",
      "getHasFullFunctionality",
      "getChangeOptionsPostData",
      "getQuantity",
      "getBaseUrl",
      "getIsSummaryFooterExpanded",
      "getSweetAlert",
      "getIsUploaded",
      "getUploadedFilesStatus",
      "getIsAnyPreflightCheckLoading",
      "getCallChangeOptionPerType",
      "getQuantityField",
      "getChangeOptionsData",
      "getShowAddToCart",
      "getQuantity",
      "getIsMobile",
      "getIsUploadedForAnyProductPart",
      "getIsLfp"
    ]),
    getDisableClass: function () {
      return this.getIsChangeOptionsLoading ||
        this.getFilesConnectLoading ||
        this.getNumberOfActiveUploads > 0
        ? "disable"
        : "";
    }
  },
  methods: {
    ...mapActions(["setQuantityField", "completePersonalization"]),
    onClickAddToCartWithSweetAlert: function (event) {
      const preflightFailed = Object.values(this.getUploadedFilesStatus).some(
        upload => upload.preflight_passed === false
      );

      if (this.getIsUploadedForAnyProductPart) {
        if (this.getHasFullFunctionality) {
          if (preflightFailed) {
            this.getSweetAlert({
              text: i18n.t(
                "Your file has not fully passed the preflight stage, would you like to upload a new file, or add to basket and seek assistance from our customer services team?"
              ),
              icon: "info",
              showCancelButton: true,
              showConfirmButton: true,
              cancelButtonText: i18n.t("Return to screen"),
              confirmButtonText: i18n.t("Add to basket & seek assistance")
            }).then(result => {
              if (result.isConfirmed) {
                this.onClickAddToCart(event);
              }
            });
          } else {
            this.getSweetAlert({
              text: i18n.t(
                "By adding to basket you are confirming that you have inspected your previews and happy for your project to be produced"
              ),
              icon: "info",
              showCancelButton: true,
              showConfirmButton: true,
              cancelButtonText: i18n.t("Back one step"),
              confirmButtonText: i18n.t("Add to basket")
            }).then(result => {
              if (result.isConfirmed) {
                this.onClickAddToCart(event);
              }
            });
          }
        } else {
          this.onClickAddToCart(event);
        }
      } else {
        this.getSweetAlert({
          text: i18n.t("You have not uploaded a file"),
          icon: "info",
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: i18n.t("Back one step"),
          confirmButtonText: i18n.t("Add to basket and upload later")
        }).then(result => {
          if (result.isConfirmed) {
            this.onClickAddToCart(event);
          }
        });
      }
    },
    onClickAddToCart: function (event) {
      var valid = this.validate();
      if (!valid) {
        return;
      }
      if (this.getAddToCartCallbacks) {
        R.forEach(callback => {
          if (typeof callback === "function") callback(event);
        }, this.getAddToCartCallbacks);
      }

      var qty = this.getChangeOptionsData.qty;
      if (qty == undefined) {
        // happens for personlization when opened in iframe
        qty = this.getQuantity;
      }
      if (!qty) {
        qty = 1;
        this.setQuantityField(qty);
        return;
      }

      var onCartData = this.getChangeOptionsPostData(false);
      if (!this.getCallChangeOptionPerType) {
        onCartData.qty = qty;
      }
      if (this.getIsLfp) {
        var payload = {
          onCartDataEncoded: btoa(JSON.stringify(onCartData)),
          onCartData: onCartData,
          callbackFucntion: this.getOnCartSubmitCallback
        };
        this.completePersonalization(payload);
      } else {
        this.getOnCartSubmitCallback(onCartData);
      }
    },

    validate: function () {
      return this.getIsValidForm(this);
    }
  }
});
